<template>
  <footer class="footer">
      <!-- Footer Links -->
  <div class="container-fluid text-center text-white p-1 p-md-3 p-lg-5">

    <!-- Grid row -->
    <div class="row w-100 w-md-75 w-lg-75 m-auto">

        <!-- Grid column -->
        <div class="col-12 col-md-6 col-lg-4 col-xl-4">
          <img class="logo-footer" src="@/assets/img/logo-progresso.png" width="150" alt="">
        </div>

        <!-- Grid column -->
        <div class="col-12 col-md-6 col-lg-4 col-xl-4">
          <div class="text-left">
            <h2>Get in Touch</h2>
            <h4>El Salvador</h4>
            <p>San Salvador<br>
            Email: info@theprogressolabs.com<br>
            WhatsApp: +503 7468 0823</p>
          </div>
        </div>

        <!-- Grid column -->
        <div class="col-12 col-md-6 col-lg-4 col-xl-4">
          <ul class="menu-footer text-left">
            <li><a href="#home">Home</a></li>
            <li><a href="#about">About Us</a></li>
            <li><a href="#services">Services</a></li>
            <li><a href="#team">Team</a></li>
            <li><a href="#credentials">Our Credentials</a></li>
          </ul>
        </div>

    </div>
    <!-- Grid row -->

  </div>
  <!-- Footer Links -->

  <!-- Copyright -->
  <div class="footer-copyright text-center py-3 text-white">PROgressoLabs© 2020</div>
  <!-- Copyright -->
  </footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style>

</style>